import Tooltip from "@material-ui/core/Tooltip";
import React, { Component } from "react";
import PtsConfirmDialogue from "../ptsAlert/PtsConfirmDialogue";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
export class RemoveContactButton extends Component {
  confirmDialogueRef = React.createRef();
  constructor(props) {
    let domainObject = props.domainObject ? props.domainObject : "";
    super(props);
    this.state = {
      domainObject: domainObject,
      title: props.title ? props.title : "Remove Confirmation",
      text: props.text ? props.text : domainObject,
      onClick: props.onClick,
      caption: props.caption,
      pageId: this.props.pageId,
      hideToolTip: props.hideToolTip,
      btnName: props.btnName,
    };
  }

  deleteConfirmed() {
    if (this.confirmDialogueRef && this.confirmDialogueRef.current) {
      this.confirmDialogueRef.current.setState({ open: false });
    }
    if (this.state.onClick) {
      this.state.onClick();
    }
  }

  onClick() {
    if (
      this.confirmDialogueRef &&
      this.confirmDialogueRef.current &&
      this.confirmDialogueRef.current.state.open === false
    ) {
      this.confirmDialogueRef.current.handleClickOpen();
    }
  }
  render() {
    this.confirmDialogueRef = React.createRef();
    return (
      <span
        onClick={this.onClick.bind(this)}
        style={{
          cursor: "pointer",
          fontSize: "x-larger",
          alignItems: "center",
        }}
      >
        <PtsConfirmDialogue
          ref={this.confirmDialogueRef}
          title={this.state.title}
          btnName={this.state.btnName}
          text={this.props.text ? this.props.text : this.props.domainObject}
          open={false}
          pageId={this.props.pageId}
          confirmCallback={this.deleteConfirmed.bind(this)}
        />
        <Tooltip title="Remove" classes={{ popper: "custom-tooltip" }} arrow>
          <PersonRemoveIcon
            style={{
              // borderRadius: "60%",
              // border: "solid 1px #6A7B8E",
              color: "#e60000",
              padding: "2.5px",
            }}
          />
        </Tooltip>
      </span>
    );
  }
}
export default RemoveContactButton;
